import codeDeleteOnImg from "images/ic_code_delete_on.svg";
import codeDeleteOffImg from "images/ic_code_delete_off.svg";
import zoomInImg from "images/ic_code_zoom_in.svg";
import zoomOutImg from "images/ic_code_zoom_out.svg";
import magicImg from "images/ic_magic.svg";

import "./index.scss";

export default function (props) {
  const {canZoomIn, canZoomOut, onClickZoomIn, onClickZoomOut, isDeletePopupOpen, onClickCodeDelete, onClickPrettify} = props;
  return (
    <div className="ace-editor_utils">
      <div className={`ace-editor_util ace-editor_prettify`} onClick={onClickPrettify}>
        <img src={magicImg} alt="magic" />
      </div>
      <div className={`ace-editor_util ace-editor_util-code_delete`} onClick={onClickCodeDelete}>
        {isDeletePopupOpen ? <img src={codeDeleteOnImg} alt="codeDeleteOnImg" /> : <img src={codeDeleteOffImg} alt="codeDeleteOffImg" />}
      </div>
      <div className={`ace-editor_util ace-editor_util-zoom_in ${canZoomIn ? "" : "ace-editor_util-disabled"}`} onClick={onClickZoomIn}>
        <img src={zoomInImg} alt="zoomIn" />
      </div>
      <div className={`ace-editor_util ace-editor_util-zoom_out ${canZoomOut ? "" : "ace-editor_util-disabled"}`} onClick={onClickZoomOut}>
        <img src={zoomOutImg} alt="zoomOut" />
      </div>
    </div>
  );
}
